// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"339a8055","732":"79459909"}[chunkId] + ".chunk.js";
};